export default {
  description: 'Your changes and your projects only get stored in your browser\'s cache. Clearing your browsing data will result in losing your projects.'
}
